"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SiteUrls_1 = require("@tableau/shared-urls/lib/src/SiteUrls");
var React = require("react");
var reselect_1 = require("reselect");
var UrlSearchFunctions_1 = require("../../urls/UrlSearchFunctions");
var UrlSearchProvider_1 = require("../../urls/UrlSearchProvider");
function constructNewSearchForFlowOutputFieldSelection(search, flowOutputFieldId) {
    var paramValuesMap = UrlSearchFunctions_1.searchToParamValuesMap(search);
    var flowOutputFieldIds = paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.field];
    if (flowOutputFieldIds && flowOutputFieldIds.indexOf(flowOutputFieldId) >= 0) {
        UrlSearchFunctions_1.removeParamValue(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.field, flowOutputFieldId);
    }
    else {
        UrlSearchFunctions_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.field, [flowOutputFieldId]);
    }
    return UrlSearchFunctions_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchForFlowOutputFieldSelection = constructNewSearchForFlowOutputFieldSelection;
function constructNewSearchWithClearedFlowOutputFieldSelection(search) {
    var paramValuesMap = UrlSearchFunctions_1.searchToParamValuesMap(search);
    var flowOutputFieldIds = paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.field];
    if (flowOutputFieldIds) {
        UrlSearchFunctions_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.field, []);
    }
    return UrlSearchFunctions_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchWithClearedFlowOutputFieldSelection = constructNewSearchWithClearedFlowOutputFieldSelection;
function constructNewSearchForOutputStepSelection(search, outputStepId) {
    var paramValuesMap = UrlSearchFunctions_1.searchToParamValuesMap(search);
    // If we're switching to a new output step, clear the field filter.
    var outputSteps = paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.outputStep];
    var currentOutputStepId = outputSteps && outputSteps.length > 0 ? outputSteps[0] : null;
    if (currentOutputStepId !== outputStepId) {
        UrlSearchFunctions_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.field, []);
    }
    UrlSearchFunctions_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.outputStep, [outputStepId]);
    return UrlSearchFunctions_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchForOutputStepSelection = constructNewSearchForOutputStepSelection;
var FlowSubplaceParamsProvider = /** @class */ (function (_super) {
    __extends(FlowSubplaceParamsProvider, _super);
    function FlowSubplaceParamsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowSubplaceParamsProvider.prototype.render = function () {
        var _this = this;
        return (React.createElement(UrlSearchProvider_1.UrlSearchProvider, null, function (urlSearch) {
            return React.createElement(FlowSubplaceParamsProviderInternal, { urlSearch: urlSearch }, _this.props.children);
        }));
    };
    return FlowSubplaceParamsProvider;
}(React.Component));
exports.FlowSubplaceParamsProvider = FlowSubplaceParamsProvider;
var FlowSubplaceParamsProviderInternal = /** @class */ (function (_super) {
    __extends(FlowSubplaceParamsProviderInternal, _super);
    function FlowSubplaceParamsProviderInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable: typedef
        _this.memoizedGetFirstParamValueAsSet = reselect_1.defaultMemoize(UrlSearchFunctions_1.getFirstParamValueAsSet);
        _this.memoizedGetSingleParamValue = reselect_1.defaultMemoize(UrlSearchFunctions_1.getSingleParamValue);
        _this.clearFlowOutputFieldSelection = function () {
            var urlSearch = _this.props.urlSearch;
            var newSearchWithClearedFieldSelection = constructNewSearchWithClearedFlowOutputFieldSelection(urlSearch.value);
            urlSearch.update(newSearchWithClearedFieldSelection);
        };
        _this.updateFlowOutputFieldSelection = function (fieldId) {
            var urlSearch = _this.props.urlSearch;
            var newSearch = constructNewSearchForFlowOutputFieldSelection(urlSearch.value, fieldId);
            urlSearch.update(newSearch);
        };
        _this.updateOutputStepSelection = function (outputStepId) {
            var urlSearch = _this.props.urlSearch;
            var newSearch = constructNewSearchForOutputStepSelection(urlSearch.value, outputStepId);
            urlSearch.update(newSearch);
        };
        return _this;
    }
    // tslint:enable: typedef
    FlowSubplaceParamsProviderInternal.prototype.render = function () {
        return this.props.children({
            urlSearchValue: this.props.urlSearch.value,
            selectedFlowOutputFieldIds: this.memoizedGetFirstParamValueAsSet(this.props.urlSearch.value, SiteUrls_1.CatalogUrlParamKeys.field),
            selectedOutputStepId: this.memoizedGetSingleParamValue(this.props.urlSearch.value, SiteUrls_1.CatalogUrlParamKeys.outputStep),
            updateFlowOutputFieldSelection: this.updateFlowOutputFieldSelection,
            clearFlowOutputFieldSelection: this.clearFlowOutputFieldSelection,
            updateOutputStepSelection: this.updateOutputStepSelection
        });
    };
    return FlowSubplaceParamsProviderInternal;
}(React.Component));
//# sourceMappingURL=FlowSubplaceParamsProvider.js.map